import apiClient from './client';
import type { CountingSessionResponse } from '../types/counting';

const skipRedirectOn404Config = { skipRedirectOn404: true } as never;

export const howardApi = {
  startSession: async (): Promise<CountingSessionResponse> => {
    const response = await apiClient.post<CountingSessionResponse>(
      '/howard-problems/session',
      undefined,
      skipRedirectOn404Config
    );
    return response.data;
  },
};
